import React from 'react';

import { createBrowserRouter } from 'react-router-dom';

import About from '../pages/About';
import Contact from '../pages/Contact';
import GameApi from '../pages/GameApi';
import Home from '../pages/Home';
import Products from '../pages/Products';
import Providers from '../pages/Providers';
import SelfServiceSolution from '../pages/SelfServiceSolution';
import Services from '../pages/Services';
import Solution from '../pages/Solution';
import WhiteLabel from '../pages/WhiteLabel';
import AppLayout from './AppLayout';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'products',
        element: <Products />,
      },
      {
        path: 'services',
        element: <Services />,
      },
      {
        path: 'providers',
        element: <Providers />,
      },
      // {
      //   path: 'about-us',
      //   element: <About />,
      // },
      // {
      //   path: 'contact',
      //   element: <Contact />,
      // },
    ],
  },
  {
    path: '/game-apis',
    element: <GameApi />,
  },
  {
    path: '/turnkey',
    element: <Solution />,
  },
  {
    path: '/self-service',
    element: <SelfServiceSolution />,
  },
  {
    path: '/white-label',
    element: <WhiteLabel />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/about-us',
    element: <About />,
  },
]);
